// admin/src/config/adminConfig.js
export const ADMIN_CREDENTIALS = {
  email: "",
  password: "",
  name: "",
  role: "admin",
};

export const WARDEN_CREDENTIALS = {
  email: "",
  password: "",
  name: "",
  role: "warden",
};

export const HARDCODED_ADMINS = [];

export default {
  ADMIN_CREDENTIALS,
  WARDEN_CREDENTIALS,
  HARDCODED_ADMINS,
};
